import { Injectable } from '@angular/core';
import { RegionsEnum } from 'src/common-panel/enums/regions-enum';
import { ThemesEnum } from 'src/common-panel/enums/themes-enum';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ThemeService
{

  private _currentTheme: ThemesEnum = ThemesEnum.theme1

  set currentTheme(value: ThemesEnum)
  {
    this._currentTheme = value;
  }

  get currentTheme(): ThemesEnum
  {
    return this._currentTheme;
  }

  constructor() { }


  getLogoPath()
  {

    if (environment.development)
    {
      if (environment.region == RegionsEnum.NA)
      {
        return `/assets/${ this.currentTheme.toLowerCase() }/logo/logo_SilentCloud_DEV_NA.png`
      } else
      {
        return `/assets/${ this.currentTheme.toLowerCase() }/logo/logo_SilentCloud_DEV_EU.png`
      }
    } else
    {
      if (environment.region == RegionsEnum.NA)
      {
        return `/assets/${ this.currentTheme.toLowerCase() }/logo/logo_SilentCloud_PROD_NA.png`
      } else
      {
        return `/assets/${ this.currentTheme.toLowerCase() }/logo/logo_SilentCloud_PROD_EU.png`
      }
    }

  }


  getCurrentName()
  {
    return 'kkk'
  }
}
